import React, { useState, useEffect } from "react";
import Header from "./Header";
import SideMenu from "./SideMenu";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import config from './config';
import './App.css';

function ReporteHoras() {
  const location = useLocation();
  const [dataLogin, setDataLogin] = useState([]);
  const [reports, setReports] = useState([]);
  const [maquinariasOptions, setMaquinariasOptions] = useState([]);
  const [clientesOptions, setClientesOptions] = useState([]);
  const [operadores, setOperadores] = useState([]);

  useEffect(() => {
    if (location.state) {
      const receivedData = location.state;
      setDataLogin(receivedData);
      obtenerMaquinarias();
      obtenerClientes();
      obtenerOperadores();
    }
  }, [location]);

  const obtenerMaquinarias = async () => {
    try {
      const response = await fetch(`${config.apiBaseUrl}/maquinaria.php`);
      const data = await response.json();

      if(data && data[0].id_maquinaria){
        const sinBombaHormigon = data.filter(item => item.id_maquinaria !== 1);
        setMaquinariasOptions(sinBombaHormigon);
      }
    } catch (error) {
      setMaquinariasOptions([]);
    }
  };

  const obtenerClientes = async () => {
    try {
      const response = await fetch(`${config.apiBaseUrl}/cliente.php`);
      const data = await response.json();

      if(data && data[0].id_cliente){
        setClientesOptions(data);
      }
    } catch (error) {
      setClientesOptions([]);
    }
  };

  const obtenerOperadores = async () => {
    try {
      const response = await fetch(`${config.apiBaseUrl}/reporte_horas.php`);
      const data = await response.json();

      if(data && data[0].id_usuario){
        setOperadores(data);
      }
    } catch (error) {
      setOperadores([]);
    }
  };

  const [clienteSelected, setClienteSelected] = useState('');
  const [obras, setObras] = useState([]);

  const handleClienteSelect = async (clienteSelected) => {
    setClienteSelected(clienteSelected);
    await obtenerObras(clienteSelected);

    setFormConsultaData({
      ...formConsultaData,
      ["id_cliente"]: clienteSelected,
    });

    //console.log(formConsultaData);
  };
  
  const obtenerObras = async (cliente) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/reporte_estado_pago.php?id_cliente=${cliente}`
      );
      const data = await response.json();
      if (data && data[0].id_obra) {
        setObras(data);
      }
    } catch (error) {
      setObras([]);
    }
  };

  //Filtro Servicios
  const [filtroReports, setFiltroEstadoPagoBH] = useState('');
  const manejarCambioFiltro = (event) => {
    setFiltroEstadoPagoBH(event.target.value);
  };

  const reportsFiltrados = reports.filter((item) =>
    item.nombre_obra.toLowerCase().includes(filtroReports.toLowerCase())
  );

  const currentDate = new Date().toISOString().split('T')[0];
  const [formConsultaData, setFormConsultaData] = useState({
    id_maquinaria: 0,
    id_cliente: 0,
    id_obra: 0,
    id_usuario: 0,
    fecha_inicio: currentDate,
    fecha_fin: currentDate
  });

  const handleFormConsultaData = (e) => {
    const { name, value } = e.target;

    setFormConsultaData({
      ...formConsultaData,
      [name]: value
    });
  };

  const handleBuscarEstadoPagoClick = async (event) => {
    event.preventDefault();

    try {
      const responseReports = await fetch(
        `${config.apiBaseUrl}/reporte_horas.php`,
        {
          method: "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json', 
          },
          body: JSON.stringify(formConsultaData),
        }
      );

      const dataReports = await responseReports.json();

      if (dataReports && dataReports[0].id_report) {
        setReports(dataReports);
      }

    } catch (error) {
      console.log(error);
      setReports([]);
    }
  }

  const exportToExcel = () => {
    const ahora = new Date();
    const fechaFormateada = formatearFecha(ahora);

    const arregloExportar = reports.map(obj => {
      return {
        ["Maquinaria"]: obj.nombre_maquinaria,
        ["Report"]: obj.id_report,
        ["Fecha Report"]: obj.fecha_report,
        ["Nombre Cliente"]: obj.nombre_cliente,
        ["Nombre Obra"]: obj.nombre_obra,
        ["Operador"]: obj.nombre_operador,
        ["Ayudante 1"]: obj.ayudante_1,
        ["Ayudante 2"]: obj.ayudante_2,        
        ["Número"]: obj.numero,
        ["Modelo"]: obj.modelo,
        ["Total Horas Trabajadas"]: obj.total_horas_trabajadas
      };
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(arregloExportar);
    XLSX.utils.book_append_sheet(wb, ws, 'Horas Trabajadas');
    XLSX.writeFile(wb, 'Horas Trabajadas ' + fechaFormateada + '.xlsx');
  };

  const formatearFecha = (fecha) => {
    const dia = String(fecha.getDate()).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const year = fecha.getFullYear();
    const hora = String(fecha.getHours()).padStart(2, '0');
    const minutos = String(fecha.getMinutes()).padStart(2, '0');

    return `${dia}-${mes}-${year} ${hora}_${minutos}`;
  };

  return (
    <div className="d-flex" style={styles.mainContainer}>
      <SideMenu dataLogin={dataLogin} />
      <div className="w-100">
        <Header dataLogin={dataLogin} />
        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <div className="d-flex gap-md-2 mb-3">
                <div>
                  <label className="form-label">Maquinaria</label>
                  <select className="form-select" name="id_maquinaria" value={formConsultaData.id_maquinaria} onChange={handleFormConsultaData}>
                    <option value="0">Todos</option>
                    {maquinariasOptions.map((maquinaria, index) => (
                      <option key={index} value={maquinaria.id_maquinaria}>{maquinaria.maquinaria}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="form-label">Cliente</label>
                  <select className="form-select" name="cliente" value={clienteSelected} onChange={(e) => handleClienteSelect(e.target.value)}>
                    <option value="0">Todos</option>
                    {clientesOptions.map((cliente) => (
                      <option key={cliente.id_cliente} value={cliente.id_cliente}>{cliente.nombre_cliente}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="form-label">Obra</label>
                  {obras.length > 0 ? (
                    <select className="form-select" name="id_obra" value={formConsultaData.id_obra} onChange={handleFormConsultaData}>
                      <option value="0">Todos</option>
                      {obras.map((obra) => (
                        <option key={obra.id_obra} value={obra.id_obra}>{obra.nombre}</option>
                      ))}
                    </select>
                  ) : (
                    <select className="form-select" name="id_obra">
                      <option value="0">Todos</option>
                    </select>
                  )}
                </div> 
                <div>
                  <label className="form-label">Operador</label>
                  {operadores.length > 0 ? (
                    <select className="form-select" name="id_usuario" value={formConsultaData.id_usuario} onChange={handleFormConsultaData}>
                      <option value="0">Todos</option>
                      {operadores.map((operador) => (
                        <option key={operador.id_usuario} value={operador.id_usuario}>{operador.nombre_operador}</option>
                      ))}
                    </select>
                  ) : (
                    <select className="form-select" name="id_obra">
                      <option value="0">Todos</option>
                    </select>
                  )}
                </div>  
                <div>
                  <label className="form-label">Fecha Inicio</label>
                  <input
                    className="form-control"
                    type="date"
                    name="fecha_inicio"
                    value={formConsultaData.fecha_inicio}
                    onChange={handleFormConsultaData}
                  />
                </div>
                <div className="">
                  <label className="form-label">Fecha Fin</label>
                  <input
                    className="form-control"
                    type="date"
                    name="fecha_fin"
                    value={formConsultaData.fecha_fin}
                    onChange={handleFormConsultaData}
                  />
                </div>     
                <div>
                  <label className="form-label d-block">&nbsp; </label>
                  <button className="btn btn-yellow" onClick={handleBuscarEstadoPagoClick}>
                    <i className="bi bi-search"></i> Buscar
                  </button>
                </div>   
              </div>
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center border-bottom-0 p-3 bg-white">
                  <h4>Reporte de Horas Trabajadas</h4>
                  <div className="d-flex gap-md-2">
                    <div className="input-group w-auto">
                      <span className="input-group-text" id="search-folio">
                        <i className="bi bi-search"></i>
                      </span>
                      <input type="text" className="form-control" placeholder="Obra..." aria-describedby="search-folio" onChange={manejarCambioFiltro}/>
                    </div>
                    {reports.length > 0 ? (
                      <button className="btn btn-success" onClick={exportToExcel}><i className="bi bi-download"></i> Exportar Excel</button>
                    ) : (
                      <button className="btn btn-success" disabled><i className="bi bi-download"></i> Exportar Excel</button>
                    )}
                  </div>
                </div>
                <div className="card-body card-body-fh card-body-filter p-0">
                  <div className="table-responsive  mytable-container">
                    <table className="table table-hover mb-0">
                      <thead>
                        <tr className="table-active border-top border-bottom">
                          <th scope="col" className="ps-3">Maquinaria</th>
                          <th scope="col">Report</th>
                          <th scope="col">Fecha Report</th>
                          <th scope="col">Cliente</th>
                          <th scope="col">Obra</th>
                          <th scope="col">Operador</th>
                          <th scope="col">Ayudante 1</th>
                          <th scope="col">Ayudante 2</th>
                          <th scope="col">Número</th>
                          <th scope="col">Modelo</th>
                          <th scope="col" className="fw-bold text-dark pe-3">Total Horas Trabajadas</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportsFiltrados.length > 0 ? (
                          reportsFiltrados.map((report, index) => (
                            <tr key={index}>
                              <td className="ps-3">{report.nombre_maquinaria}</td>
                              <td>{report.id_report}</td>
                              <td>{report.fecha_report}</td>
                              <td>{report.nombre_cliente}</td>
                              <td>{report.nombre_obra}</td>
                              <td>{report.nombre_operador}</td>
                              <td>{report.ayudante_1}</td>
                              <td>{report.ayudante_2}</td>
                              <td>{report.numero}</td>
                              <td>{report.modelo}</td>
                              <td className="pe-3"><span className="text-orange">{report.total_horas_trabajadas}</span></td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={9}>No se encontró el detalle de horas trabajadas</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  mainContainer: {
    height: "100vh",
  },
};

export default ReporteHoras;
